import { ConcreteEncodable } from "./ConcreteEncodable";

import { SessionInvalidationImplEncoder } from "../../encoder/SessionInvalidationImplEncoder";

import * as CubiqTS from "../../index";
import { SessionInvalidation } from "../SessionInvalidation";

export class SessionInvalidationImpl extends ConcreteEncodable implements SessionInvalidation {
  public static enType: string = "com.bcdfx.broker.SessionInvalidationImpl";

  /*FID=2*/
  public connectionSessionId: string;
  /*FID=100*/
  public messageId: string;
  /*FID=10010*/
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SessionInvalidationImplEncoder.Instance;
    this.setEncodableType(SessionInvalidationImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SessionInvalidationImpl[" +
      "connectionSessionId=" +
      this.connectionSessionId +
      "messageId=" +
      this.messageId +
      "sessionOnly=" +
      this.sessionOnly +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
